export default "__VITE_ASSET__DbfHIo6g__"